<template>
	<layout-splash title="Verify Email Address">
		<form class="h-full flex-col">
			<content-verify-thanks :user="user" :resent="resent" />
		</form>
	</layout-splash>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		resent: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
